import React from "react";
import "./partners-about.css";

const PartnershipSection = () => {
  return (
    <section className="partnership-unique-section">
      <div className="partnership-unique-wrapper">
        <h2 className="partnership-unique-title">Our Global Collaborations</h2>
        
        <div className="partnership-unique-text-wrapper">
          <p className="partnership-unique-text">
            At Sreenathji Enterprises, we take pride in our strategic collaborations with leading Indian
            and multinational corporations that are at the forefront of technological innovation. These
            partnerships enable us to source and deliver world-class technology products that drive
            performance, scalability, and impact across industries. Our partners are not just suppliers —
            they are pioneers in their domains, specializing in their own fields. Together, we ensure that 
            our clients have access to the most advanced, reliable, and future-ready technologies available globally.
          </p>

          <p className="partnership-unique-text">
            Aligned with our commitment to a sustainable future, we work exclusively with organizations
            that share our vision of environmental responsibility and ethical innovation. From eco-friendly
            product design to transparent supply chains and circular economy initiatives, our partners
            are leaders in driving measurable sustainability outcomes. These are not ordinary partnerships. 
            We collaborate with extraordinary organizations — global trailblazers known for their integrity, 
            innovation, and impact. Together, we are shaping a smarter, greener, and more connected future.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PartnershipSection;
